export const FeedbackPage = () => {
    return (
        <div className="w-full min-h-full font-inter flex flex-col py-5 px-10 overflow-auto bg-white">
            <div className="flex justify-between">
                <div>
                    <h1 className="font-bold text-2xl">Feedback</h1>
                </div>
            </div>
            <main className="w-full gap-[15px] flex mt-[20px]">
                {/* <iframe src="https://www.notioniframe.com/notion/1b8zbdepjk9" className="w-full h-screen border-0 p-0" style={{ scrollbarWidth: "none" }}></iframe> */}
            </main>
        </div >
    )
}